// extracted by mini-css-extract-plugin
export default {"popupIndicator":"_1qsPfePl3cbvdU4rU6G9j"};